import React, { useEffect, useMemo, useState } from "react";
import { ApiCall } from "../../../../helper/axios";
import HwSelect from "../../../../component/HwSelect";
import HwDatePicker from "../../../../component/HwDatePicker";
import { SearchIcon, UserIcon } from "../../../../helper/HwIcon";
import { calcNights } from "../../../../helper/commonFunction";
import { RoomInfoPopup } from "../../popups/RoomInfoPopup";

export const HotelSearchForm = ({
  values,
  setFieldValue,
  setFieldTouched,
  errors = {},
  touched = {},
  setShowRoomInfoModal,
  staticData,
  countries,
  showRoomInfoModal,
  handleSubmit,
  searchUpdate = false,
  personError = '',
  sameDateError, setSameDateError, header = {},
  submitCount = 0,
}) => {
  const roomLine = `${values?.noOfRooms} Rooms ${values?.noOfAdult}
    Adults ${values?.noOfChild} Child`;
  const [loading, setLoading] = useState(false);
  const searchDebounceRef = React.useRef(null);
  useEffect(() => {
    if (showRoomInfoModal && values?.nationality) {
      setFieldValue(`nationality`, values?.nationality);
      setFieldValue(`nationalityValue`, values?.nationality?.value);
    }
  }, [showRoomInfoModal, values?.nationality]);

  const staticCities = staticData?.cities ?? [];
  const staticHotels = staticData?.hotels ?? [];
  const staticOptions = useMemo(() => {
    const _staticOptions = [
      ...(staticHotels?.map?.((c) => ({
        value: c?.code,
        label: c?.name,
        fullRegionName: c?.fullRegionName ?? `${c?.address}, ${c?.cityName}`,
        details: c,
      })) ?? []),
      ...(staticCities?.map?.((c) => ({
        value: c?.code,
        label: c?.fullRegionName,
        fullRegionName: c?.name,
        isCity: true,
        details: c,
      })) ?? []),
    ];
    return _staticOptions;
  }, [staticCities?.length, staticHotels?.length]);

  const [defaultOptionsCountryWise, setDefaultOptionsCountryWise] = useState(
    staticOptions
  );

  const searchStaticData = React.useCallback(
    async (keyword) => {
      try {
        const response = await ApiCall("GET",`/hotels/search-static-data?search=${keyword ?? ""}&timeZone=${Intl.DateTimeFormat().resolvedOptions().timeZone }`);

        const cities = response?.data?.data?.cities;
        const hotels = response?.data?.data?.hotels;

        const options = [
          ...(cities?.map?.((c) => ({
            value: c?.code,
            label: c?.fullRegionName,
            fullRegionName: c?.name,
            isCity: true,
            details: c,
          })) ?? []),
          ...(hotels?.map?.((c) => ({
            value: c?.code,
            label: c?.name,
            fullRegionName: c?.fullRegionName ?? `${c?.address}, ${c?.cityName}`,
            details: c,
          })) ?? []),
        ];
        setDefaultOptionsCountryWise(options);
        return options.slice?.(0, 40) ?? [];
      } catch (error) {
        return [];
      }
    },
    [staticOptions]
  );

  const debouncedSearchStaticData = React.useCallback(
    (keyword) => {
      if (searchDebounceRef.current) {
        clearTimeout(searchDebounceRef.current);
      }
      return new Promise((resolve) => {
        if (!keyword || keyword.length < 3) {
          setLoading(false);
          const options = staticOptions.slice(0, 30);
          setDefaultOptionsCountryWise(staticOptions);
          resolve(options);
          return;
        }
        setLoading(true);
        searchDebounceRef.current = setTimeout(async () => {
          try {
            const options = await searchStaticData(keyword);
            resolve(options || []);
          } catch (e) {
            resolve([]);
          } finally {
            setLoading(false);
          }
        }, 450);
      });
    },
    [searchStaticData, staticOptions]
  );
  useEffect(() => {
    setDefaultOptionsCountryWise(staticOptions);
  }, [staticOptions]);
  const uniqueOptions = Array.from(
    new Map(defaultOptionsCountryWise.map((item) => [item.value, item])).values()
  );
  const searchOptions = [...uniqueOptions]
  const [selectedSearch, setSelectedSearch] = useState(null);
  useEffect(() => {
    if (!header || Object.keys(header).length === 0) {
      return;
    }
    if (header?.searchFor) {
      const matched =
        searchOptions.find((o) => o.label === header.searchFor) ||
        staticOptions.find((o) => o.label === header.searchFor);
      if (matched) {
        setSelectedSearch(matched);
        setFieldValue("city", matched);
      } else {
        setSelectedSearch(header)
        setFieldValue("city", header);
      }
    }
  }, [header]);


  return (
    <>
      <div className="hw-input--groupColLeft">
        <div className="paasenger-modal">
          {showRoomInfoModal ? (
            <RoomInfoPopup
              values={values}
              setFieldValue={setFieldValue}
              onClose={() => {
                setShowRoomInfoModal(false);
              }}
              personError={personError}
            />
          ) : null}
        </div>
        <div className="hw-input--multicityGroup">
          <div className="hw-row--input hw-row--inputFirst" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <div className="hw-input--switchGroup">
              <HwSelect
                placeholder="Search by City or Hotel"
                options={values?.keyword?.length > 3 ? searchOptions : staticOptions}
                onChangeFn={(selected) => {
                  if (!selected) {
                    setFieldValue("cityValueExists", selected);
                    setFieldValue("hid", selected);
                  }
                  setFieldValue("city", selected);
                  setFieldValue("cityChanged", true);
                  setSelectedSearch(selected);
                }}
                value={selectedSearch}
                menuChnageFn={(value) => { }}
                onInputChangeFn={(value) => {
                  setFieldValue("keyword", value);
                }}
                isMulti={false}
                type={"hotels"}
                isError={errors?.city && touched?.city}
                inputValue={values.keyword ?? ""}
                loading={loading}
                className="hotel-search-form"
                async
                loadOptions={debouncedSearchStaticData}
                defaultOptions={staticOptions.slice(0, 30)}
              />
              {errors?.city && (touched?.city || submitCount > 0) && !(searchUpdate && values?.keyword) && (
                <span className="hw-input--error-search left">{`Please select city or hotel
`}</span>
              )}
            </div>
<div className="hw-hotel-search nationality-select" style={{ display: "none" }}>
           
              <HwSelect
                className="hotel-search-form"
                placeholder="Nationality"
                options={countries ?? []}
                onChangeFn={(selected) => {
                  setFieldValue(`nationality`, selected);
                  setFieldValue(`nationalityValue`, selected?.value);
                }}
                value={values?.nationality ?? ""}
                menuChnageFn={(value) => { }}
                onInputChangeFn={(value) => { }}
                loading={false}
                type={"country"}
                isError={errors?.nationalityValue && touched?.nationalityValue}
              />
              {errors?.nationalityValue && (touched?.nationalityValue || submitCount > 0) && (
                <span className="hw-input--error-search left">{errors.nationalityValue}</span>
              )}
           
          </div>

            <HwDatePicker
              wrapperClassName="hw-date-range-picker"
              monthsShown={2}
              showPreviousMonths={false}
              onChangeFn={(date) => {
                setFieldValue("checkinDate", date?.[0]);
                setFieldValue("checkoutDate", date?.[1]);
                setSameDateError("")
              }}
              type="Check In | Check Out"
              isError={
                (errors?.checkinDate && (touched?.checkinDate || submitCount > 0)) ? errors?.checkinDate : (errors?.checkoutDate && (touched?.checkoutDate || submitCount > 0)) ? errors?.checkoutDate : sameDateError ? sameDateError : null
              }
              selectsRange
              startDate={values?.checkinDate}
              endDate={values?.checkoutDate}
              suffix={` ${calcNights(
                values?.checkinDate,
                values?.checkoutDate
              )}`}
            />
            <div
              title={roomLine}
              style={{
                border: personError && "1px red solid",
                position: "relative",
              }}
              className={`hw-row--gap4 hw-input--input ${values?.roomOptionModal ? "active" : ""
                }`}
              onClick={(e) => {
                e.stopPropagation();
                if (values?.nationality) {
                  setFieldValue(`nationality`, values?.nationality);
                  setFieldValue(`nationalityValue`, values?.nationality?.value);
                }
                setShowRoomInfoModal(true);
              }}
            >
              <UserIcon />
              <span className="hw-text--hidden hw-text14 hw-text--muted hw-line--height1">
                Person & Rooms
              </span>
              <span className="hw-text--hidden hw-blue hw-fontBold hw-line--height1">
                {roomLine}
              </span>
              {(errors?.roomOptionModal ||
                errors.roomOptionModal?.["infants"]) && (
                  <span className="hw-input--error-search right">
                    {errors.roomOptionModal}
                  </span>
                )}
              {personError && (
                <span className="hw-input--error-search right">{personError}</span>
              )}
            </div>
          </div>

          
        </div>
      </div>
      <button
        className="hw-filter--searchBtn"
        style={{ display: "flex", alignItems: "center", gap: "6px" }}
        onClick={() => {
          setFieldTouched("city", true);
          setFieldTouched("checkinDate", true);
          setFieldTouched("checkoutDate", true);
          setFieldTouched("nationalityValue", true);
          handleSubmit();
        }}
        type="submit"
      >
        <SearchIcon /> {searchUpdate ? "Update" : "Search"}
      </button>
    </>
  );
};